import React, { useState, useRef, useEffect } from "react";
import SSPCommonModal from "../../CommonComponents/SSPCommonModal/SSPCommonModal";
import { PageBar, SSPCommonButton, } from "../../CommonComponents";
import Grid from "@mui/material/Grid";
import { Box, Card, CardContent, CardHeader, Divider, Link, Button, Tooltip, Typography, IconButton, } from "@mui/material";
import "react-datepicker/dist/react-datepicker.css";
import { post } from "../../services";
import Cookies from "js-cookie";
import Loader from "../../CommonComponents/Loader";
import axios from "axios";
import styles, { boxSX } from "./Styles";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import { Download } from "@mui/icons-material";
import { isDevelopment } from "../../Hooks/constants";

const PoToReopen = ({ token }) => {
    const id = Cookies.get("ssp_id");

    // Dynamic Base URL based on Environment Variables
    const base = isDevelopment
        ? `${process.env.REACT_APP_MDM_DEV || process.env.REACT_APP_SSP_MDM_DEV}`
        : `${process.env.REACT_APP_MDM_PROD || process.env.REACT_APP_SSP_MDM_PROD}`;

    const [loading, setLoading] = useState(false);
    const [modalOpener, setmodalOpener] = useState(false);
    const [message, setmessage] = useState("");
    const fileInputRef = useRef(null);
    const [selectedFile, setSelectedFile] = useState(null);
    const [row, setRows] = useState([]);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));

    useEffect(() => {
        rowFetch();
    }, []);

    const rowFetch = async () => {
        let response = await post(
            base,
            {
                "action": "upload_details",
                "module": "po_to_reopen",
                "user_id": id,
                rawPath: "/po_to_reopen",
            },
            true,
            false
        );
        if (response?.status === "success" || response?.body?.status === "success") {
            const rowsData = response?.body?.data?.map((row, index) => ({
                ...row,
                id: index + 1,
            }));
            setRows(rowsData);

        } else {
            setmessage("No Rows");
            setmodalOpener(true);
        }
    };

    const downloadProcessLog = async (logId) => {
        setLoading(true)

        let response = await post(
            base,
            {
                "action": "process_log",
                "log_id": String(logId),
                rawPath: "/po_to_reopen",
            },
            true,
            false
        );
        if (response?.status === "success" || response?.body?.status === "success") {
            setLoading(false)
            window.open(response?.body?.data?.url || response?.url);

        } else {
            setLoading(false)
            setmessage(response?.body?.message || response?.message);
            setmodalOpener(true);
        }
    }

    const handleUpload = async () => {
        if (selectedFile) {
            if (selectedFile instanceof File) {
                const fileExtension = selectedFile.name.split('.').pop().toLowerCase();
                if (fileExtension !== "xlsx") {
                    setmessage("Only .xlsx files are allowed.");
                    setmodalOpener(true);
                    return;
                }
            }
            setLoading(true)
            let filenameWithTimestamp;
            if (selectedFile instanceof File) {
                const timestamp = new Date()
                    .toISOString()
                    .replace(/[-:.]/g, "")
                    .slice(0, 15);
                // filenameWithTimestamp = `${selectedFile?.name
                //     .split(".")
                //     .slice(0, -1)
                //     .join(".")}_${timestamp}.${selectedFile?.name?.split(".")?.pop()}`;

                const folderName = "po_to_reopen";
                filenameWithTimestamp = `${folderName}/${selectedFile.name
                    .split(".")
                    .slice(0, -1)
                    .join(".")}_${timestamp}.${selectedFile.name.split(".").pop()}`;
            } else {
                filenameWithTimestamp = selectedFile;
            }
            let presignedUrlResponse = await post(
                base,
                {
                    file_name: filenameWithTimestamp?.replace(/[()]/g, ""),
                    "user_id": id,
                    "action": "get_pre_url",
                    rawPath: "/po_to_reopen",
                },
                true,
                false
            );
            if (presignedUrlResponse?.status === 'error' || presignedUrlResponse?.body?.status === 'error') {
                setmessage(presignedUrlResponse?.data?.message);
                setmodalOpener(true);
                return
            }

            const presignedUrl = presignedUrlResponse.body.data;

            if (!presignedUrl) {
                console.error("Presigned URL is not valid");
                return;
            }
            if (selectedFile instanceof File) {
                const fileUploaded = await uploadFileWithPresignedUrl(
                    selectedFile,
                    presignedUrl
                );
                if (fileUploaded) {
                    let response = await post(
                        base,
                        {
                            "action": "upload_excel",
                            file_name: presignedUrl.fields.key,
                            "user_id": id,
                            rawPath: "/po_to_reopen",
                        },
                        true,
                        false
                    );
                    if (response?.status === "success" || response?.body?.status === "success") {

                        setLoading(false)
                        setmessage(response?.message || response?.body?.message || "File Uploaded");
                        setmodalOpener(true);
                        if (fileInputRef.current) {
                            fileInputRef.current.value = "";
                        }
                        setSelectedFile(null);
                        setTimeout(() => {
                            window.location.reload();
                        }, 2000);

                    } else if (response?.status === "Error" || response?.status === "error" || response?.body?.status === "Error" || response?.body?.status === "error") {
                        setLoading(false)

                        setmessage(response?.message || response?.body?.message);
                        setmodalOpener(true);
                        if (fileInputRef.current) {
                            fileInputRef.current.value = "";
                        }
                        setSelectedFile(null);

                    }

                    else {
                        setLoading(false)

                        setmessage(response?.body?.message || response?.message);
                        setmodalOpener(true);
                        if (fileInputRef.current) {
                            fileInputRef.current.value = "";
                        }
                        setSelectedFile(null);

                    }

                }

                if (!fileUploaded) {
                    if (fileInputRef.current) {
                        fileInputRef.current.value = "";
                    }
                    setLoading(false)
                    setSelectedFile(null);

                    console.error("File upload failed");
                    return;
                }
            }

        } else {
            setLoading(false)
            setmessage("Please select file to upload");
            setmodalOpener(true);
        }
    }
    const uploadFileWithPresignedUrl = async (filetoUpload, generatedUrl) => {
        try {
            const fileUploadData = new FormData();
            Object.keys(generatedUrl.fields).forEach((key) => {
                fileUploadData.append(key, generatedUrl.fields[key]);
            });
            fileUploadData.append("file", filetoUpload);
            const fileUploaded = await uploadFile(generatedUrl.url, fileUploadData);
            if (fileUploaded) {
                return true;
            } else {
                console.error("File upload failed");
                return false;
            }
        } catch (error) {
            console.error("Error during file upload:", error);
            throw error;
        }
    };

    const uploadFile = async (url, formData) => {
        try {
            const response = await axios.post(url, formData);

            if (response.status === 204) {
                console.log("File upload successful with status 204");
                return true;
            }

            if (response.status >= 200 && response.status < 300) {
                console.log("File upload successful");
                return true;
            } else {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }
        } catch (error) {
            console.error("Error during file upload:", error);
            throw error;
        }
    };

    const handleDownloadSampleFile = async () => {
        setLoading(true)
        let response = await post(
            base,
            {
                "action": "download_template",
                "file_name": "samplefiles/po_to_reopen_sample.xlsx",
                rawPath: "/po_to_reopen",
            },
            true,
            false
        );
        if (response?.status === "success" || response?.body?.status === "success" || response?.statusCode === 200) {
            setLoading(false)
            window.open(response?.body?.data?.url);
        } else {
            setLoading(false)

            setmessage(response?.message || response?.body?.message);
            setmodalOpener(true);
        }

    };
    const ReasonCell = ({ value }) => {
        return (
            <Tooltip
                title={
                    <span style={{ fontSize: "16px" }}>{value}</span>
                }
            >
                <div
                    style={{
                        whiteSpace: "none",
                        textAlign: "start",
                        maxWidth: "100%",

                    }}
                >{value}</div>
            </Tooltip>
        );
    };

    const columns = [
        {
            field: 'sr_no',
            headerName: 'Sr no',
            headerAlign: 'center',
            align: 'center',
            width: isMobile ? 150 : 130,
            renderCell: (params) => (
                <div>
                    {params.id}
                </div>
            )
        },
        {
            field: "file_name",
            headerName: " File Name",
            width: isMobile ? 150 : 220,
            renderCell: (params) => <ReasonCell value={params.value ? params.value : "--"} />,
        },
        {
            field: 'updated_at',
            headerName: 'Date',
            headerAlign: 'center',
            align: 'center',
            width: isMobile ? 180 : 200,
            renderCell: (params) => <ReasonCell value={params.value ? params.value : "--"} />,
        },

        {
            field: 'status',
            headerName: 'Status',
            width: 150,
            headerAlign: 'center',
            align: 'center',
            renderCell: (params) => (
                <div style={{
                    textAlign: 'center', color: params.value === 'Success' ? 'green' : 'red',
                }}>{params.value}</div>
            ),
        },

        {
            field: 'affected_count',
            headerName: (
                <div style={{ textAlign: 'center', whiteSpace: 'pre-wrap' }}>
                    No of records processed
                </div>
            ),
            width: isMobile ? 180 : 200,
            headerAlign: 'center',
            align: 'center',
            renderCell: (params) => (
                <div style={{ textAlign: 'center' }}>{params?.value ? params?.value : '0'}</div>
            ),
        },

        {
            field: "current_status",
            headerName: "Progress",
            headerAlign: "center",
            align: "center",
            width: isMobile ? 170 : 200,
            renderCell: (params) => {
                return (
                    <Box
                        display="flex"
                        flexDirection="column"
                        alignItems="center"
                        justifyContent="center"
                        width="100%"
                        height="100%"
                        textAlign="center"
                        style={{
                            lineHeight: 1.5,
                        }}
                    >
                        <Typography
                            style={{
                                fontSize: "0.9rem",
                                marginBottom: "4px",
                                color: params.value === 'Partial File Uploaded ' ? 'red' : params.value === 'File Uploaded' && 'green'
                            }}
                        >
                            {params.value}
                        </Typography>

                    </Box>
                );
            },
        },
        {
            field: "process_log",
            headerName: "Process Log",
            headerAlign: "center",
            width: isMobile ? 155 : 200,
            align: "center",

            renderCell: (params) => (
                <IconButton
                    aria-label="Download Process Log"
                    onClick={() => downloadProcessLog(params.row.log_id)}
                >
                    <Download color="primary" />
                </IconButton>
            ),
        },

    ];
    return (
        <Box>
            <Loader loading={loading} />
            <PageBar
                text="Fusion : Po To Reopen"
            />
            <Card sx={styles.assetmasterCard} >

                <CardHeader
                    p={2}
                    sx={styles.cardHeader}
                    title={" Upload excel containing Po To Reopen"}
                    titleTypographyProps={{
                        sx: { fontSize: "16px", fontWeight: "600", lineHeight: "16px", color: "#0160F1", },
                    }}
                />
                <Divider />
                <CardContent sx={styles.assetmasterCardContent} >
                    <Grid container spacing={2} >
                        <Grid item xs={12} sm={6} md={6} lg={4} xl={4} sx={styles.locContainer} >
                            <Box p={2} sx={{ ...styles.fileStyle, width: isMobile ? '90%' : '85%' }} >
                                <Box p={1} sx={styles.fileInputStyle} >
                                    <input
                                        type="file"
                                        ref={fileInputRef}
                                        multiple={false}
                                        onChange={(e) => {
                                            setSelectedFile(e.target.files[0]);
                                        }}
                                        style={{ width: isMobile ? '90%' : '85%' }}
                                    />
                                </Box>
                            </Box>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={3.5} xl={4} sx={{ ...styles.dwnldAssetMasterbttnStyle, marginLeft: isMobile ? 3 : 0 }} >
                            <SSPCommonButton
                                btnText="Save data"
                                btnFunction={() => {
                                    handleUpload()
                                }}
                            />
                        </Grid>
                    </Grid>
                    <Box p={1} sx={styles.buttonBox} >
                        <Link
                            component={"button"}
                            color={"#0160F1"}
                            sx={boxSX}
                            onClick={handleDownloadSampleFile}
                        >
                            {"Download Sample File"}
                        </Link>

                    </Box>
                </CardContent>
                <Card sx={styles.card} >
                    <CardHeader
                        p={2}
                        sx={styles.cardHeader}
                        title={"Uploaded Files"}
                        titleTypographyProps={{
                            sx: { fontSize: "16px", fontWeight: "600", lineHeight: "16px", color: "#0160F1", },
                        }}
                        action={
                            <>
                                <Button onClick={() => window.location.reload()}>
                                    Refresh Page
                                </Button>
                            </>
                        }
                    />
                    <Divider />
                    <CardContent sx={styles.assetmasterCardContent} >
                        <Box
                            sx={{
                                backgroundColor: "#FFFFFF",
                                borderBottomRightRadius: "5px",
                                borderBottomLeftRadius: "5px",
                                padding: isMobile ? "8px" : "16px",
                                height: 700,
                            }}
                        >
                            <DataGrid
                                rowHeight={80}
                                showCellRightBorder={true}

                                sx={{
                                    ".MuiDataGrid-columnHeaderTitle": {
                                        fontWeight: "bold !important",
                                        fontSize: isMobile ? "0.7rem" : "0.875rem",
                                    },
                                    ".MuiDataGrid-cell": {
                                        fontSize: isMobile ? "0.6rem" : "0.8rem",
                                        padding: isMobile ? "4px" : "8px",
                                    },
                                    ".MuiDataGrid-root": {
                                        minWidth: isMobile ? "50%" : "auto",
                                    },
                                    overflowX: "auto",

                                }}
                                rows={row}
                                columns={columns}

                                initialState={{
                                    pagination: {
                                        paginationModel: {
                                            pageSize: 10,
                                        },
                                    },
                                }}
                                headerClassName="header-center"
                                rowsPerPageOptions={[10]}
                                pageSize={10}
                                getRowId={(row) => row.id}
                                components={{
                                    Toolbar: GridToolbar,
                                }}
                                componentsProps={{
                                    Toolbar: {
                                        showQuickFilter: true,
                                        quickFilterProps: { debounceMs: 500 },
                                    },
                                }}
                            />
                        </Box>

                    </CardContent>
                </Card>
            </Card>
            {
                modalOpener && (
                    <SSPCommonModal
                        open={modalOpener}
                        handleOpenClose={setmodalOpener}
                        message={message}
                    />
                )
            }
        </Box >
    )
}

export default PoToReopen


